import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.create-statement-item.views.StatementItemForm`

export default defineMessages({
  descriptionLabel: {
    id: `${scope}.descriptionLabel`,
    defaultMessage: 'Description',
  },
  descriptionRequiredError: {
    id: `${scope}.descriptionRequiredError`,
    defaultMessage: 'Description is required',
  },
  dateLabel: {
    id: `${scope}.dateLabel`,
    defaultMessage: 'Statement date',
  },
  dateRequiredError: {
    id: `${scope}.dateRequiredError`,
    defaultMessage: 'Statement date is required',
  },
  amountLabel: {
    id: `${scope}.amountLabel`,
    defaultMessage: 'Total cost',
  },
  amountPlaceholder: {
    id: `${scope}.amountPlaceholder`,
    defaultMessage: '0.00',
  },
  amountRequiredError: {
    id: `${scope}.amountRequiredError`,
    defaultMessage: 'Total cost is required',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save item',
  },
})
